import { createContext, useContext, useState, useCallback } from "react";

type FilterResetContextType = {
  resetKey: number;
  triggerReset: () => void;
};

const FilterResetContext = createContext<FilterResetContextType | null>(null);

export const FilterResetProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [resetKey, setResetKey] = useState(0);

  const triggerReset = useCallback(() => {
    setResetKey((prev) => prev + 1);
    // return "Reset triggered!";
  }, []);

  return (
    <FilterResetContext.Provider value={{ resetKey, triggerReset }}>
      {children}
    </FilterResetContext.Provider>
  );
};

export const useFilterReset = () => {
  const context = useContext(FilterResetContext);
  if (!context) {
    throw new Error("useFilterReset must be used within a FilterResetProvider");
  }
  return context;
};
